/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Upload_Person_Document_ActionInputs */



/**
* | output |
* | --- |
* | "Add a document" |
*
* @param {Nudge_Upload_Person_Document_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_upload_person_document_action = /** @type {((inputs?: Nudge_Upload_Person_Document_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Upload_Person_Document_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Document toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un document")
	return /** @type {LocalizedString} */ ("Add a document")
});